import type { Destination } from "@/lib/dashboard-home/destinations";
import { navigationActionState } from "@/lib/navigation-action";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Ouvre une destination de l'accueil. Une page du site internet sans site
 * configuré ouvre la modale « pas de site » (cf. Header).
 */
export function useHomeNavigation() {
  const navigate = useNavigate();
  const [noCmsOpen, setNoCmsOpen] = useState(false);

  const go = (destination: Destination) => {
    if (!destination) return;
    if (destination.kind === "no-cms") {
      setNoCmsOpen(true);
      return;
    }
    navigate(destination.to, {
      state: destination.action
        ? { ...destination.state, ...navigationActionState(destination.action) }
        : destination.state,
    });
  };

  return { go, noCmsOpen, setNoCmsOpen };
}
